export enum AnalyticsNames {
  PositiveEngagementStarted = 'Positive Engagement Started',
  PositiveEngagementPassed = 'Positive Engagement Passed',
  PositiveEngagementFailed = 'Positive Engagement Failed',
}
